/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * AGENTTRIGGERSERVICE - GERENCIAMENTO DE TRIGGERS DE AGENTES
 *
 * Este serviço gerencia os TRIGGERS associados às versões de agentes.
 * Responsável por:
 * - Buscar triggers de versões específicas de agentes
 * - Gerenciar eventos e gatilhos de execução
 * - Encapsular chamadas à API de triggers
 *
 * ENDPOINT: /agent-versions/{versionId}/triggers
 * ESTADO: Triggers configurados para versões de agentes
 * PADRÃO: Facade para simplificar operações de triggers
 *
 * RELACIONAMENTO: Integra com agentVersionService para versões de agentes
 */

import { get } from "@/shared/utils/fetchApi";

/**
 * Serviço para gerenciar triggers de agentes
 * Implementa o padrão Facade para encapsular as chamadas à API relacionadas a triggers de agentes
 */
export class AgentTriggerService {

  /**
   * Obtém todos os triggers de uma versão de agente pelo ID da versão
   *
   * @param versionId ID da versão do agente
   * @returns Status da operação no formato { data, error }
   */
  static async getByVersionId(
    versionId: string,
  ): Promise<{ data: any[] | null; error: any }> {
    try {
      // v2 muda o path (/agent-versions/:id/triggers) mas mantém o envelope { success, data }
      const result = await get<{ data: any[] }>(
        `/agent-versions/${versionId}/triggers`,
      );

      return { data: result.data, error: null };
    } catch (error) {
      console.error(
        `[AgentTriggerService] Erro ao buscar triggers da versão ${versionId}:`,
        error,
      );
      return { data: null, error };
    }
  }
}
